import { SORTORDER, SortOrder } from "types/sort"
import { workingHour } from "types/stations"

export const sleep = (delay: number) =>
    new Promise((resolve) => setTimeout(resolve, delay))

export const capitalize = (str: string) =>
    str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()

function descendingComparator(a: string, b: string) {
    if (b.toLowerCase() < a.toLowerCase()) {
        return -1
    }
    if (b.toLowerCase() > a.toLowerCase()) {
        return 1
    }
    return 0
}

function getComparator(order: SortOrder): (a: string, b: string) => number {
    return order === SORTORDER.DESC
        ? (a, b) => descendingComparator(a, b)
        : (a, b) => -descendingComparator(a, b)
}

export function stableSort<T>(orderBy: keyof T, order: SortOrder) {
    const comparator = getComparator(order)

    return (a: T, b: T) => {
        const aOrder = a[orderBy] != null ? a[orderBy].toString() : ""
        const bOrder = b[orderBy] != null ? b[orderBy].toString() : ""
        return comparator(aOrder, bOrder)
    }
}

export const numberComparator = (a: number, b: number) => {
    if (b < a) {
        return -1
    }
    if (b > a) {
        return 1
    }
    return 0
}

export const dateComparator = (d1: Date, d2: Date) => {
    const a = d1.getTime()
    const b = d2.getTime()
    if (b < a) {
        return -1
    }
    if (b > a) {
        return 1
    }
    return 0
}

export const stringComparator = (a: string, b: string) => {
    if (b.toLowerCase() < a.toLowerCase()) {
        return -1
    }
    if (b.toLowerCase() > a.toLowerCase()) {
        return 1
    }
    return 0
}

export const ArrayComparator = (a: string[], b: string[]) => {
    if (b.length < a.length) {
        return -1
    }
    if (b.length > a.length) {
        return 1
    }
    return 0
}

export const convertDateTime = (inputDateString: string) => {
    const date = new Date(inputDateString)
    const formattedDate = date.toLocaleDateString("fr-FR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    })
    const formattedTime = date.toLocaleTimeString("fr-FR", {
        hour: "2-digit",
        minute: "2-digit",
    })

    return `${formattedDate} ${formattedTime}`
}

export const checkStationOpenStatus = (workingHour: workingHour): boolean => {
    if (workingHour.isAlwaysOpen) return true
    if (!workingHour.openOn) return false

    const now = new Date()
    const currentDay = now
        .toLocaleString("en-US", { weekday: "long" })
        .toLowerCase()
    const currentTime = now.toTimeString().slice(0, 5)

    const todaySchedule = workingHour.openOn[currentDay] || []

    return todaySchedule.some(
        ({ start, end }) => currentTime >= start && currentTime <= end
    )
}

export function getLastSegmentForSidebarMenu(path: string): string {
    if (!path) return ""
    const cleanedPath = path.endsWith("/") ? path.slice(0, -1) : path
    const segments = cleanedPath.split("/")
    return segments.length ? segments[segments.length - 1] : ""
}
